exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2H4-O {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  padding: 10px 15px;\n  color: #A89A72;\n  cursor: pointer;\n}\n._1zO8g {\n  padding: 15px 20px;\n  border-bottom: 1px solid #a0a0a0;\n}\n", ""]);

// Exports
exports.locals = {
	"btnClose": "_2H4-O",
	"tab": "_1zO8g"
};